export default "__VITE_ASSET__i5FN9kxj__"